import {get} from "./rest.js";
import {Challenge} from "./data/challenge.js";

function display_error(error_msg) {
    const timeline_container = document.getElementById('timeline-container');
    timeline_container.style.display = 'none';
    const progress_container = document.getElementById('progress-container');
    progress_container.style.display = 'none';

    const error_container = document.getElementById('error-container');
    const msg = document.getElementById('error-message');
    msg.innerText = error_msg;
    error_container.style.display = 'block';
}

function build_timeline(challenge) {
    const start = challenge.get_start_date();
    const end = challenge.get_end_date();
    const current = Date.now();
    const days_left = Math.ceil((end - current) / (1000 * 60 * 60 * 24));
    const percent_complete = Math.ceil((current - start) / (end - start) * 100);

    const timeline_container = document.getElementById('timeline-container');
    timeline_container.style.display = 'block';

    const days_container = document.createElement('div');
    days_container.className = 'days-display';
    const days_display = document.createElement('span');
    days_display.innerText = days_left + ' days left';
    days_container.appendChild(days_display);
    timeline_container.appendChild(days_container);

    const bar_container = document.createElement('div');
    bar_container.className = 'bar-container';
    timeline_container.appendChild(bar_container);

    const progress = document.createElement('div');
    progress.className = 'timeline-bar';
    progress.style.width = percent_complete + '%';
    bar_container.appendChild(progress);

    timeline_container.appendChild(document.createElement('hr'));
}

function build_progress(challenge) {
    const progress_container = document.getElementById('progress-container');
    progress_container.style.display = 'block';

    const total = challenge.get_work().get_chapter_count();
    const sorted = challenge.get_challengers().sort((a, b) => b.get_chapters_read() - a.get_chapters_read());
    sorted.forEach(challenger => {
        const logged = challenger.get_chapters_read();
        const complete = challenger.get_completed_date() !== null;

        const name_container = document.createElement('div');
        name_container.className = 'name-display';
        const name_display = document.createElement('span');
        let text = challenger.get_name();
        if (complete) {
            text = text + ' - Completed!';
        } else {
            text = text + ' - ' + logged + '/' + total + ' Read';
        }
        name_display.innerText = text;
        name_container.appendChild(name_display);
        progress_container.appendChild(name_container);

        const bar_container = document.createElement('div');
        bar_container.className = 'bar-container';
        progress_container.appendChild(bar_container);

        let percent_complete = Math.ceil(logged / total * 100);
        if (percent_complete > 100) {
            percent_complete = 100;
        }
        const progress = document.createElement('div');
        progress.className = 'progress-bar';
        progress.style.width = percent_complete + '%';
        bar_container.appendChild(progress);
    });
}

async function initialize() {
    const challenge_result = await get(new Map(), 'challenges', 'get_current_challenge');
    if (!challenge_result.is_successful()) {
        console.error(challenge_result.get_error_message());
        display_error("There is no current challenge or there was an unknown error");
    } else {
        const challenge = Challenge.from_json(challenge_result.get_data());
        build_timeline(challenge);
        build_progress(challenge);
    }
}

initialize();